import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import {
  LayoutDashboard,
  Settings,
  BarChart,
  Users2,
  PanelLeftClose,
  PanelLeftOpen,
  TrendingUp,
  RefreshCw,
  Building2,
  Wallet,
  Database,
  Link2,
  Webhook,
  Layers,
  ClipboardList,
} from 'lucide-react'
import { Button } from './ui/button'
import { useState } from 'react'

const ORCAMENTO_V2_ENABLED = String(import.meta.env.VITE_ORCAMENTO_V2_ENABLED || 'false') === 'true'

const menuItems = [
  {
    title: 'Menu Principal',
    items: [
      {
        title: 'Visão Geral',
        href: '/dashboard',
        icon: LayoutDashboard,
      },
      {
        title: 'Análise por Centro',
        href: '/dashboard/centro-custo',
        icon: Building2,
      },
      {
        title: 'Saldo e Movimentações',
        href: '/dashboard/saldo-movimentacoes',
        icon: Wallet,
      },
      {
        title: 'Orçamento',
        href: '/dashboard/orcamento',
        icon: TrendingUp,
      },
      {
        title: 'Realizado (financeiro)',
        href: '/dashboard/orcamento/realizado-financeiro',
        icon: ClipboardList,
      },
      {
        title: 'Análise Orçamento',
        href: '/dashboard/orcamento/analise',
        icon: BarChart,
      },
      ...(ORCAMENTO_V2_ENABLED
        ? [{
            title: 'Validação V2',
            href: '/dashboard/orcamento/validacao-v2',
            icon: BarChart,
          }]
        : []),
      {
        title: 'Sincronizar Pipefy',
        href: '/dashboard/orcamento/sincronizar',
        icon: RefreshCw,
      },
      {
        title: 'Criar Database Pipefy',
        href: '/dashboard/pipefy/criar-database',
        icon: Database,
      },
      {
        title: 'Vincular Databases',
        href: '/dashboard/pipefy/vincular-databases',
        icon: Link2,
      },
      {
        title: 'Áreas de Negócio',
        href: '/dashboard/areas',
        icon: Layers,
      },
      {
        title: 'Webhooks Pipefy',
        href: '/dashboard/pipefy/webhooks',
        icon: Webhook,
      },
      {
        title: 'Disparador n8n',
        href: '/dashboard/pipefy/disparador-webhook',
        icon: Webhook,
      },
      {
        title: 'Testar Atualização',
        href: '/dashboard/orcamento/testar-atualizacao',
        icon: RefreshCw,
      },
    ],
  },
  {
    title: 'Sistema',
    items: [
      {
        title: 'Configurações',
        href: '/dashboard/configuracoes',
        icon: Settings,
      },
    ],
  },
]

interface SidebarProps {
  className?: string
}

export function Sidebar({ className }: SidebarProps) {
  const location = useLocation()
  const pathname = location.pathname
  const [isCollapsed, setIsCollapsed] = useState(false)

  return (
    <div className={cn(
      "relative hidden border-r bg-card transition-all duration-300 ease-in-out md:flex md:flex-col",
      isCollapsed ? "w-16" : "w-64",
      className
    )}>
      <Button
        variant="outline"
        size="icon"
        className="absolute top-6 -right-4 z-50 h-8 w-8 rounded-full border bg-background shadow md:flex hover:bg-muted"
        onClick={() => setIsCollapsed(!isCollapsed)}
        title={isCollapsed ? "Expandir menu" : "Recolher menu"}
        style={{ borderRight: 0 }}
      >
        {isCollapsed ? (
          <PanelLeftOpen className="h-5 w-5" />
        ) : (
          <PanelLeftClose className="h-5 w-5" />
        )}
      </Button>
      <div className="pt-8 px-6">
        <div className={cn(
          "flex items-center gap-2 mb-6",
          isCollapsed && "justify-center"
        )}>
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center shrink-0">
            <Users2 className="w-5 h-5 text-primary-foreground" />
          </div>
          {!isCollapsed && (
            <>
              <span className="text-lg font-semibold">Orçamento Solis</span>
            </>
          )}
        </div>

        <nav className="space-y-6">
          {menuItems.map((group) => (
            <div key={group.title}>
              {!isCollapsed && (
                <h4 className="text-xs uppercase text-muted-foreground mb-2 px-2">
                  {group.title}
                </h4>
              )}
              <div className="space-y-1">
                {group.items.map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    className={cn(
                      'flex items-center rounded-lg transition-colors',
                      isCollapsed
                        ? pathname === item.href
                          ? 'justify-center px-4 py-2 gap-0'
                          : 'justify-center px-2 py-2 gap-0'
                        : 'px-2 py-2 gap-3',
                      pathname === item.href
                        ? 'bg-primary/10 text-primary font-medium'
                        : 'text-muted-foreground hover:bg-muted'
                    )}
                    title={isCollapsed ? item.title : undefined}
                  >
                    <item.icon className="w-4 h-4 shrink-0" />
                    {!isCollapsed && item.title}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>
    </div>
  )
} 